import { TransactionSources, TransactionTypes } from "@custom-types/credit-types";

/** @returns True if the object type is Credit Transaction */
export function isCreditTransaction(data) {
  if (!data || typeof data !== "object") {
    return false;
  }
  const toCheck = data;
  return typeof toCheck.id === "string" && typeof toCheck.timestamp === "string" && isCreditTransactionSource(toCheck.source) && isCreditTransactionAction(toCheck.action) && isCreditTransactionContext(toCheck.context) && isCreditTransactionResult(toCheck.result) && Array.isArray(toCheck.tags) && (toCheck.visibility === "External" || toCheck.visibility === "Internal");
}

/** @returns True if the object type is Credit Transaction Source */
export function isCreditTransactionSource(source) {
  if (!source || typeof source !== "object") {
    return false;
  }
  const s = source;
  return typeof s.type === "string" && Object.values(TransactionSources).includes(s.type) && typeof s.version === "string";
}

/** @returns True if the object type is Credit Transaction Action */
export function isCreditTransactionAction(action) {
  if (!action || typeof action !== "object") {
    return false;
  }
  const a = action;
  if (typeof a.type !== "string" || !Object.values(TransactionTypes).includes(a.type)) {
    return false;
  }
  switch (a.type) {
    case TransactionTypes.insertTokens:
      return isInsertTokensAction(a);
    case TransactionTypes.createTokens:
      return isCreateTokensAction(a);
    case TransactionTypes.activateTokens:
      return isActivateTokensAction(a);
    case TransactionTypes.consumeTokens:
      return isConsumeTokensAction(a);
    case TransactionTypes.expireTokens:
      return isExpireTokensAction(a);
    default:
      return false;
  }
}

/** @returns True if the action data is an insert action */
export function isInsertTokensAction(action) {
  if (!action || typeof action !== "object") {
    return false;
  }
  const a = action;
  return a.type === TransactionTypes.insertTokens && typeof a.data?.tokenAmount === "number" && typeof a.data?.reason === "string" && typeof a.data?.trigger === "string";
}

/** @returns True if the action data is a create action */
export function isCreateTokensAction(action) {
  if (!action || typeof action !== "object") {
    return false;
  }
  const a = action;
  return a.type === TransactionTypes.createTokens && typeof a.data?.tokenAmount === "number" && typeof a.data?.startDate === "string" && typeof a.data?.endDate === "string" && typeof a.data?.subscriptionId === "string";
}

/** @returns True if the action data is an activate tokens action */
export function isActivateTokensAction(action) {
  if (!action || typeof action !== "object") {
    return false;
  }
  const a = action;
  return a.type === TransactionTypes.activateTokens && typeof a.data?.tokenAmount === "number" && typeof a.data?.endDate === "string" && typeof a.data?.subscriptionId === "string";
}

/** @returns True if the action data is a consumption action */
export function isConsumeTokensAction(action) {
  if (!action || typeof action !== "object") {
    return false;
  }
  const a = action;
  return a.type === TransactionTypes.consumeTokens && typeof a.data?.tokenAmount === "number" && typeof a.data?.consumptionReason === "string";
}

/** @returns True if the action data is a expire action */
export function isExpireTokensAction(action) {
  if (!action || typeof action !== "object") {
    return false;
  }
  const a = action;
  return a.type === TransactionTypes.expireTokens && typeof a.data?.expirationReason === "string";
}

/** @returns True if the object type is Credit Transaction Context */
export function isCreditTransactionContext(context) {
  if (!context || typeof context !== "object") {
    return false;
  }
  const c = context;
  return typeof c.companyId === "string";
}

/** @returns True if the object type is Credit Transaction Result */
export function isCreditTransactionResult(result) {
  if (!result || typeof result !== "object") {
    return false;
  }
  const r = result;
  const data = r.data && typeof r.data === "object" && !Array.isArray(r.data) ? r.data : undefined;
  switch (r.type) {
    case "TokensInserted":
      return data !== undefined && (typeof data.subscriptionId === "string" || data.subscriptionId === null);
    case "TokensCreated":
    case "TokensActivated":
      return r.outcome === undefined || typeof r.outcome === "string";
    case "TokensConsumed":
      return data !== undefined && Array.isArray(data.subscriptionIds);
    case "TokenInsertionFailed":
    case "TokenConsumptionFailed":
      return data !== undefined && typeof data.failureReason === "string";
    case "TokenInsertionRejected":
    case "TokenConsumptionRejected":
      return data !== undefined && typeof data.rejectionReason === "string";
    case "TokensExpired":
      return data !== undefined && (typeof data.subscriptionId === "string" || data.subscriptionId === null) && typeof data.expiredAmount === "number";
    default:
      return false;
  }
}